export default {
  ru: {
    title: "РЕМОНТ ЭЛЕКТРОДВИГАТЕЛЕЙ ПОСТОЯННОГО ТОКА",
    content: "<p class='py-2'>Наше предприятие предлагает выполнить для Вас ремонт электрических двигателей постоянного тока мощностью от 5 кВт до 10 000 кВт, весом до 100 тн, для металлургических предприятий, ГОКов, цементных предприятий и прочих компаний.</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт прокатных электродвигателей постоянного тока крупного габарита;</li>\n" +
      "<li class='list-disc'>Ремонт электродвигателей постоянного тока экскаваторной группы;</li>\n" +
      "<li class='list-disc'>Ремонт генераторов постоянного тока;</li>\n" +
      "<li class='list-disc'>Ремонт крановых электродвигателей постоянного тока;</li>" +
      "<li class='list-disc'>Ремонт тяговых электродвигателей и тяговых генераторов постоянного тока.</li>" +
      "</ul>\n"
  },
  en: {
    title: "DIRECT CURRENT ELECTRIC MOTORS",
    content: "<p class='py-2'>Our enterprise offers to repair electric DC motors with power from 5 kW to 10,000 kW, weighing up to 100 tons, for metallurgical enterprises, mining and processing plants, cement enterprises and other companies.</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Repair of rolling large-size direct current electric motors;</li>\n" +
      "<li class='list-disc'>Repair of electric motors of a direct current of an excavator group;</li>\n" +
      "<li class='list-disc'>Repair of direct current generators;</li>\n" +
      "<li class='list-disc'>Repair of crane direct current motors;</li>" +
      "<li class='list-disc'>Repair of traction electric motors and traction direct current generators;</li>" +
      "</ul>\n"
  },
  ua: {
    title: "ЕЛЕКТРОДВИГУНИ ПОСТІЙНОГО СТРУМУ",
    content: "<p class='py-2'>Наше підприємство пропонує виконати для Вас ремонт електричних двигунів постійного струму потужністю від 5 кВт до 10 000 кВт, вагою до 100 тн, для металургійних підприємств, ГЗК, цементних підприємств та інших компаній.</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт прокатних електродвигунів постійного струму великого габариту;</li>\n" +
      "<li class='list-disc'>Ремонт електродвигунів постійного струму екскаваторної групи;</li>\n" +
      "<li class='list-disc'>Ремонт генераторів постійного струму;</li>\n" +
      "<li class='list-disc'>Ремонт генераторів постійного струму;</li>" +
      "<li class='list-disc'>Ремонт тягових електродвигунів і тягових генераторів постійного струму.</li>" +
      "</ul>\n"
  },
}

